import { ConfirmationService } from 'primeng/api';

import { Component, OnInit, ViewChild } from '@angular/core';
import { ConveniosServiceService } from '../convenios-service.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-convenios-pesquisa',
  templateUrl: './convenios-pesquisa.component.html',
  styleUrls: ['./convenios-pesquisa.component.css']
})
export class ConveniosPesquisaComponent implements OnInit {


  convenios: any = []

 

  constructor(
    private conveniosServiceService: ConveniosServiceService,
    private confirmationService: ConfirmationService,
    private route : Router) {
    ;

  }
  ngOnInit() {

    this.conveniosServiceService.pesquisar()
      .then((response) => this.convenios = response);

  }

  pesquisarPorNome(nome: string) {

    if (nome === "") {
      this.conveniosServiceService.pesquisar()
        .then((response) => this.convenios = response);
    }
    else {
      this.conveniosServiceService.pesquisarPorNome(nome)
        .then((response) => this.convenios = response);
    }
  }

  excluirPorId(id: string){

    this.confirmationService.confirm({
      message: 'Tem certeza que você deseja excluir esse registro ?',
      accept: () => {

        this.conveniosServiceService.excluirPorId(id)
        .then(()=> {this.pesquisarPorNome("")});
      }
    }    
    );
  }

  alterarPorId(id: string){
        this.conveniosServiceService.excluirPorId(id)
        .then(()=> {this.pesquisarPorNome("")});
  }

  detalhe(id: string){
    this.route.navigate(['/convenios/'+id])
    
}

}

